var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.firstName)?_c('div',{staticClass:"greeting"},[_c('p',{staticClass:"greeting__message"},[_vm._v(" "+_vm._s(_vm.$t(_vm.userGreeting))+",")]),_vm._v(" "),_c('p',{staticClass:"greeting__name"},[_vm._v(_vm._s(_vm.firstName))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }